export default "__VITE_ASSET__TvCP5jjt__"